import { render, staticRenderFns } from "./Subfamily.vue?vue&type=template&id=0fb08a52&"
import script from "./Subfamily.vue?vue&type=script&lang=js&"
export * from "./Subfamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports